<template>
  <div>
    <v-btn class="ml-2" depressed color="" @click="sendPush">
      <v-icon class="mr-4">mdi-email-send-outline</v-icon>
      Wyślij powiadomienie
    </v-btn>

    <PatientSendNotify :open="sendNotifyOpen" @close="sendNotifyClose" />
    <Snackbar :snackbar="snackbar" :snackbarStatus="snackbarStatus" />
  </div>
</template>

<script>
import PatientSendNotify from "@/components/PatientSendNotify.vue";
import Snackbar from "@/components/Snackbar.vue";

export default {
  components: {
    PatientSendNotify,
    Snackbar
  },
  data() {
    return {
      data: [],
      open: false,
      sendNotifyOpen: false,
      admin: false,
      userInfo: [],
      snackbar: false,
      snackbarStatus: false
    };
  },
  methods: {
    modalOpen(edit) {
      if (!edit) {
        this.userInfo = [];
      }
      this.open = true;
    },
    close(status) {
      if (status !== "close") {
        this.snackbar = true;
        this.snackbarStatus = status;
      }
      this.open = false;
    },
    userOptions(user) {
      this.userInfo = user;
      this.modalOpen(true);
    },
    itemRowClass(item) {
      return item.confirmed ? "" : "yellow lighten-4";
    },
    downloadListDoctors(e) {
      e.preventDefault();
    },
    sendPush() {
      this.sendNotifyOpen = true;
    },
    sendNotifyClose() {
      this.sendNotifyOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.nowrap {
  white-space: nowrap;
}
</style>
